import React, { useState } from "react";

export default function SaveAsModal({ initialName = "", onClose, onConfirm }) {
  const [name, setName] = useState(initialName);

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Save Workflow As</h2>
        <div className="form-group">
          <label>New Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Workflow name"
          />
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button className="btn-secondary" type="button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            type="button"
            disabled={!name.trim()}
            onClick={() => onConfirm(name.trim())}
          >
            Save Copy
          </button>
        </div>
      </div>
    </div>
  );
}
